import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormControl, FormControlProps, FormGroup } from 'react-bootstrap';
import { Overwrite } from '../../types';
import Button from '../Button';

export type BaseFormControlProps = Overwrite<
  FormControlProps,
  {
    value?: string | number | string[] | undefined;
    onChange?: (value: string | number | string[] | undefined) => void;
  }
>;

export type SearchBarProps = BaseFormControlProps & {
  placeholder?: string;
  name?: string;
  maxLength?: number;
  onClick?: (value: any) => void;
};

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder,
  value,
  onChange,
  isValid,
  isInvalid,
  className,
  name,
  onKeyDown,
  onClick,
  ...props
}) => {
  const [localValue, setLocalValue] = React.useState<any>(
    value === null ? '' : value
  );

  const setIcon = (iconName: IconProp, side: string) => (
    <FontAwesomeIcon icon={iconName} className={`icon ${side}`} />
  );

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    setLocalValue(newValue);

    if (value !== newValue) {
      onChange && onChange(newValue);
    }

    return onChange && onChange(newValue);
  };

  const handleOnClick = () => {
    if (!onClick) return false;
    onClick(localValue);
  };

  return (
    <div className={'d-flex flex-row search-bar'}>
      <FormGroup className={`${className ? className : ''}`}>
        <div className={`input-wrapper`}>
          {setIcon(light('search'), 'icon--right')}
          <FormControl
            name={name}
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={handleOnChange}
            isValid={isValid}
            isInvalid={isInvalid}
            {...props}
          />
        </div>
      </FormGroup>
      <div className={`button-wrapper`}>
        <Button onClick={handleOnClick}>
          <span className="fw-normal">SEARCH</span>
        </Button>
      </div>
    </div>
  );
};

export default SearchBar;
